<!--
* UIID: UI-DLB-SRM-131
* UI Name: Reference Files List
* Modify Date: 2020/04/16
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>{{$t('lbl.srmListManagement.referenceFilesList.page_header')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon style="right: -16px" @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <v-card-text class="files-list-data-section pa-0 pr-8 pl-8 mr-0 mb-2">
      <!-- [S]  Popup Data-->
      <v-row class="ma-0 reference-pb-search">
        <v-col cols="5" class="pa-0"></v-col>
        <v-col cols="4" class="reference-popup-info">
          <v-label>Customer</v-label>
          <div class="reference-dv-select">
            <v-select height="30" solo></v-select>
          </div>
        </v-col>
        <v-col cols="3" class="pa-0">
          <v-text-field
            v-model="search"
            class="search-matched-map-list-button custom-form-component search-button"
            outlined
            dense
            solo
            hide-details
            placeholder="Search"
            append-icon="fas fa-search"
            height="30"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pt-0 pr-0 pb-0 pl-0">
          <v-data-table
            :headers="SummDataList.headers"
            :items="atftRepoList"
            :hide-default-footer="true"
            :disable-sort="true"
            :search="search"
            :items-per-page="-1"
            class="reference-files-list-table pb-0"
            fixed-header
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="select-col">
                    <v-btn small text icon @click="inputSelectedFile(item)">
                      <v-icon color="#74C5E8" small>fas fa-check-circle</v-icon>
                    </v-btn>
                  </td>
                  <td class="reference-file-name-col">
                    <a @click="downloadReferenceFile(item)">{{ item.ATF_FILE_NAME }}</a>
                  </td>
                  <td class="customer-col">{{ item.MST_CUST_NM }}</td>
                  <td class="document-type-col">{{ item.ATF_FRMT_TP_NM }}</td>
                  <td class="updated-date-col">{{ item.ATF_UPD_DT }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- [E]  Popup Data-->
    </v-card-text>
    <v-row class="ma-0 pt-0">
      <v-col class="pa-0 text-left" cols="3"></v-col>
      <v-col class="pa-0" cols="9">
        <v-row class="ma-0">
          <v-spacer></v-spacer>
          <v-col class="pa-0 text-right" cols="6">
            <v-btn class="ma-0 btn-style btn-delete" tile dark @click="removeDialog">
              <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
              {{$t('btn.common.close')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from "vuex";
import IconSvg from "@/vue-caas/components/IconBase.vue";


// import {
//   showSuccessMessage,
//   showErrorMessage,
//   showProgress,
//   hideProgress,
//   alertSuccess,
//   closeAlert
// } from "@/vue-dlb/utils/sys-util.js";


export default {
  components: {
    DialogDrag,
    IconSvg
  },
  name: 'referenceList-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'queryList'],
  props:{
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    queryList: Function,
  },
  computed: {
    ...mapState("srmlist", {
      atftRepoList: "atftRepoList",
    }),
  },
  data(){
    return{
    search: '',
    SummDataList: {
      headers: [
        { text: 'Select', value: 'USE_YN' },
        { text: 'Reference File Name', value: 'ATF_FILE_NAME'},
        { text: 'Customer', value: 'MST_CUST_ID' },
        { text: 'Document Type', value: 'ATF_FRMT_TP',width:'130px'},
        { text: 'Updated Date', value: 'ATF_UPD_DT',width:'130px'},
      ]
    },
    ReferenceDataList: {
    header: ['SYSSTATUS','ADDBY','CUST_ID','OWNR_CUST_ID','USER_ID','ATF_PRCS_NO','SRM_PRCS_NO','ATF_FILE_NAME','FILE_ID','ATF_FILE_SIZE','file'],
      data: [{
        SYSSTATUS: '',
        ADDBY: '',
        CUST_ID: '',
        OWNR_CUST_ID: '',
        USER_ID: '',
        ATF_PRCS_NO: '',
        SRM_PRCS_NO: '',
        ATF_FILE_NAME: '',
        FILE_ID: '',
        ATF_FILE_SIZE: '',
        file:''
      }]
    },
    masterSearchItems: {
      header: ['ADMIN_YN','CUST_ID'],
      data: [{
        ADMIN_YN: '',
        CUST_ID: '',
      }],
    },
    referenceDownloadItems: {
      header: ['FILE_ID','SAVE_NAME'],
      data: [{
        FILE_ID: '',
        SAVE_NAME:''
      }],
    },
  }},

  methods: {
    queryReferenceFilesList () {
      //[2020-04-17] apply by CLV: Apply srmlist/queryMapList api
      console.log("--------- queryReferenceFilesList ----------");
      this.masterSearchItems.data[0].ADMIN_YN = $cookies.get('used-repo');
      this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');

      Store.dispatch("srmlist/queryRefFilesListFromRepo", this.masterSearchItems).then(() => {
        console.log("--------- Finished to process ----------");
        console.log(this.atftRepoList);
      });
    },
    removeDialog (dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    },
    inputSelectedFile(item){
      this.ReferenceDataList.data[0].SYSSTATUS = 'I';
      this.ReferenceDataList.data[0].ADDBY = 'LOAD';
      this.ReferenceDataList.data[0].CUST_ID = item.MST_CUST_ID;
      this.ReferenceDataList.data[0].OWNR_CUST_ID = item.OWNR_CUST_ID;
      this.ReferenceDataList.data[0].USER_ID = $cookies.get('user-id');
      this.ReferenceDataList.data[0].ATF_PRCS_NO = item.ATF_PRCS_NO;
      this.ReferenceDataList.data[0].SRM_PRCS_NO = '';
      this.ReferenceDataList.data[0].ATF_FILE_NAME = item.ATF_FILE_NAME;
      this.ReferenceDataList.data[0].FILE_ID = item.FILE_ID;
      this.ReferenceDataList.data[0].ATF_FRMT_TP = item.ATF_FRMT_TP;
      this.ReferenceDataList.data[0].ATF_FILE_SIZE = item.ATF_FILE_SIZE;
      this.ReferenceDataList.data[0].file = '' ;
      let referenceList = this.ReferenceDataList.data[0];
      this.$emit('inputSelectedFile', {referenceList, selectItem : this.options.item});
      this.removeDialog(this);
    },
    queryReferenceList () {
      //[2020-04-22] apply by CLV: Apply srmlist/queryRefFilesListFromRepo api
      console.log("--------- getSummaryList ----------");
      this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      this.masterSearchItems.data[0].ADMIN_YN =  $cookies.get('used-repo');

      Store.dispatch("srmlist/srmlist/queryRefFilesListFromRepo", this.masterSearchItems).then(() => {
        console.log("--------- Finished to process ----------");
        console.log(this.atftRepoList);
      });
    },
    downloadReferenceFile(item){
      this.referenceDownloadItems.data[0].FILE_ID = item.FILE_ID;
      this.referenceDownloadItems.data[0].SAVE_NAME = item.ATF_FILE_NAME;
      Store.dispatch("common/DownloadFileFromServer", this.referenceDownloadItems).then(() => {
        console.log("--------- Finished to process ----------");
      });
    }
  },

  created() {
    this.queryReferenceFilesList();
  },
  watch: {
  },
}
</script>

<style>
.reference-files-list-layout-dialog {
  height: 411px !important;
  width: 900px !important;
}
.reference-files-list-layout-dialog label {
  color: #bbbbbb;
}
/* .dialog-drag.reference-files-list-layout-dialog .dialog-body{
    background-color: white;
} */
.reference-files-list-layout-dialog .dialog-body .v-card__text.files-list-data-section{
    padding: 20px 15px 15px 15px !important;
    background: #FAFCFF;
    border: 1px solid #F0F7FB;
    box-sizing: border-box;
    border-radius: 3px
}
/* .reference-files-list-layout-dialog .dialog-header{
    background-color: #253C51;
    height: 60px;
} */
/* .reference-files-list-layout-dialog .v-card__title.headline.white--text{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    line-height: 29px;
    display: flex;
    align-items: center;
} */
.reference-files-list-table{
    background-color: #FFFFFF !important;
    color: black !important;
    padding-bottom: 20px;
    height: auto;
    border-bottom: 0.5px solid #D0D4DD;
}
.reference-files-list-table thead {
    background: #E4E6E8 !important;
    border: 1px solid #D0D4DD !important;
}
.reference-files-list-table thead tr th.text-start {
    color: #000000 !important;
    /* border-right: 1px solid #E0E6F2; */
    text-align: center !important;
}
.reference-files-list-table  td.reference-file-name-col,.reference-files-list-table td.customer-col,.reference-files-list-table td.document-type-col{
  text-align: left !important;
  font-size: 11px;
}
.reference-files-list-table  td.updated-date-col,.reference-files-list-table td.select-col{
  text-align: center !important;
  font-size: 11px;
}
.reference-files-list-table td {
  border-right: 1px solid #D0D4DD;
}
.reference-files-list-table td:first-child {
  border-left: 1px solid #D0D4DD;
}
.reference-files-list-table a {
  font-weight: bold;
  text-decoration: underline;
  color: #0082BA !important;
}
.reference-files-list-table .v-data-table__wrapper{
  overflow-y: auto ;
  height: 207px;
  max-height: 207px ;
}
.reference-dv-select > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot{
  padding: 0px;
  width: 125px;
  margin: 0px;
  border: 1px solid #D4D5D7;
  height: 30px;
  border-radius: 1px;
  min-height: 30px;
  box-sizing: border-box;
  box-shadow: none;
}
.reference-dv-select .v-text-field__details{
  max-height: 0px !important;
  min-height: 0px !important;
  margin: 0px !important;
  padding: 0px;
}
.reference-dv-select .v-input__control{
  min-height: 30px !important;
}
.reference-dv-select{
  float: right;
  padding: 0px 10px 0px 4px;
}
.reference-files-list-layout-dialog ::placeholder {
  color: #DFE1E5 !important;
  opacity: 1;
}
.v-icon.notranslate.fa.fa.fa.fa-search.theme--light{
  color: #DFE1E5 !important;
}
.reference-pb-search{
  padding-bottom:  5px;
}
.reference-popup-info{
  padding: 0px 0px 0px 16px;
  display: flex;
  justify-content:flex-end;
}
.reference-popup-info .v-label{
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #000000 !important;
}
.reference-files-list-table .fas.fa-check-circle.theme--light{
  font-size: 14px !important;
  line-height: 17px;
}
.reference-files-list-table thead th span {
  font-size: 11px !important;
}
.reference-files-list-table thead th{
  height :25px !important;
}

/* Theme Light */
.theme--light .reference-files-list-table thead th {
  background: #E4E6E8 !important;
}
.theme--light .reference-files-list-table th{
  border-top: 1px solid #D0D4DD !important;
  border-right: 1px solid #D0D4DD !important;
  font-size: 11px;
}
.theme--light .reference-files-list-table th:first-child {
  border-left: 1px solid #D0D4DD !important;
  border-bottom: 1px solid #D0D4DD !important;
}

/* Theme Dark */
.theme--dark .reference-popup-info .v-label {
  color: #bbbbbb !important;
}
.theme--dark .reference-files-list-table {
  border-bottom: 0.5px solid #525860;
}
.theme--dark .reference-files-list-table thead {
  background: inherit !important;
}
.theme--dark .reference-files-list-table.v-data-table thead tr:last-child th {
  background: #595B64 !important;
  color: white !important;
}
.theme--dark .reference-dv-select > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot{
  border: none;
  background-color: #3B3E49;
}
.theme--dark .reference-files-list-table .customer-col, .theme--dark .reference-files-list-table .document-type-col, .theme--dark .reference-files-list-table .updated-date-col {
  color: #bbbbbb !important;
}
.theme--dark .reference-files-list-table{
  background-color: #292c35 !important;
  border-bottom: none !important;
  color: #bbbbbb;
}
.theme--dark .reference-files-list-layout-dialog .dialog-body .v-card__text.files-list-data-section{
    background: #292C35;
    border: none;
}
.theme--dark .dialog-drag.reference-files-list-layout-dialog .dialog-body{
    border: none;
    /* background-color: #3B3E49; */
}

</style>
